import React, { useState, useEffect, useRef } from "react";
import { QRCodeCanvas  } from 'qrcode.react';
import { useReactToPrint } from "react-to-print";
import "../style/home.css";
import "../style/widget.css";
import "../style/stockitemform.css";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import Button from "@mui/material/Button";
import DeleteIcon from "@mui/icons-material/Delete";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress
  // TablePagination,
} from "@mui/material";
import axiosInstance from "../axios_helper/axiosInstance";
import ImageModal from "../components/ImageModal";

const StockItemForm = ({ categoryName }) => {
  const [formData, setFormData] = useState({
    code: "",
    gw: "",
    nw: "",
    shop: 1,
    category: "", 
    kundan: "",
    k_amt: "",
    moti: "",
    m_amt: "",
    po: "",
    p_amt: "",
    pcs: "",
    supplier: "",
    image: null,
  });
  const [stockItems, setStockItems] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [open, setOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [imageError, setImageError] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null); // Track the selected item for printing
  const printRef = useRef(null); // Reference for the item details to print
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchCategory();
    fetchStockItems();
  }, [categoryName]);

  const fetchCategory = () => {
    axiosInstance
      .get(`/categories/?name=${categoryName}`)
      .then((response) => {
        const category = response.data.find(cat => cat.name === categoryName);
        if (category) {
          setFormData(prevState => ({
            ...prevState,
            category: category.id, // Ensure this is the ID
          }));
        } else {
          console.error("Category not found");
        }
      })
      .catch((error) => {
        console.error("Error fetching category:", error);
      });
  };
  

 const fetchStockItems = () => {
  setLoading(true); // Set loading to true
  axiosInstance
    .get(`/stock-items/?category=${categoryName}`)
    .then((response) => {
      // Sort items by ID in descending order (more recent items first)
      const sortedItems = response.data.sort((a, b) => b.id - a.id);
      setStockItems(sortedItems);
    })
    .catch((error) => {
      console.error("Error fetching stock items:", error);
    })
    .finally(() => {
      setLoading(false); // Set loading to false
    });
};

  const handleChange = (e) => {
    if (e.target.name === "image") {
      setFormData({
        ...formData,
        [e.target.name]: e.target.files[0],
      });
    } else {
      setFormData({
        ...formData,
        [e.target.name]: e.target.value,
      });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
  
    // Create FormData instance
    const formDataToSend = new FormData();
    for (const key in formData) {
      if (formData.hasOwnProperty(key)) {
        formDataToSend.append(key, formData[key] || ''); // Append data, default to empty string if null
      }
    }
  
    // Send POST request
    axiosInstance
      .post("/stock-items/", formDataToSend, {
        headers: {
          'Content-Type': 'multipart/form-data' // Ensure the correct content type
        }
      })
      .then((response) => {
        console.log("Stock item added:", response.data);
        fetchStockItems(); // Refresh stock items list
        setFormData({
          code: "",
          gw: "",
          nw: "",
          shop: 1,
          category: formData.category, // Ensure category ID is included
          kundan: "",
          k_amt: "",
          moti: "",
          m_amt: "",
          po: "",
          p_amt: "",
          pcs: "",
          supplier: "",
          image: null,
        });
      })
      .catch((error) => {
        console.error("Error adding stock item:", error);
        alert(error);
        if (error.response) {
          console.log("Response data:", error.response.data);
        }
      });
  };

  const handleDeleteStockItem = (id) => {
    if (window.confirm("Are you sure you want to delete this stock item?")) {
      axiosInstance.delete(`/stock-items/${id}/`)
        .then(() => {
          console.log(`Stock item with id ${id} deleted`);
          setStockItems(stockItems.filter((item) => item.id !== id));
          alert("Stock item deleted successfully!");
        })
        .catch((error) => {
          console.error("Error deleting stock item:", error);
          alert("Failed to delete the stock item. Please try again.");
        });
    }
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const filteredStockItems = stockItems.filter(
    (item) =>
      item.code.toLowerCase().includes(searchQuery.toLowerCase())
  );


  const handleOpen = (imageUrl) => {
    setSelectedImage(imageUrl);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedImage(null);
  };

  const handleImageError = () => {
    setImageError(true);
  };

  // Print stock item details
  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    documentTitle: "",  // Empty title to avoid showing the title in the print
    pageStyle: `
      @page { 
        size: 100mm 13mm;  /* Exact label size */
        margin: 0;         /* No margin for the page */
      }
      @media print {
        body {
          margin: 0;
          padding: 0;
        }
      }
    `,
  });
  
  const printItem = (item) => {
    setSelectedItem(item);
    setTimeout(() => {
      handlePrint();
    }, 0);
  };

  return (
    <>
      <div className="home">
        <Sidebar />
        <div className="home-container">
          <Header />
          <div className="stockitemform-container">
            <div className="name_search">
              <h2>Category: {categoryName}</h2>
              <div className="search-bar">
                <input
                  type="text"
                  placeholder="Search..."
                  value={searchQuery}
                  onChange={handleSearchChange}
                />
                <SearchOutlinedIcon />
              </div>
            </div>
            <div className="label_input_form">
              <form onSubmit={handleSubmit}>
                <label>
                  Code:
                  <input
                    type="text"
                    name="code"
                    value={formData.code.toUpperCase()}
                    onChange={handleChange}
                  />
                </label>
                <label>
                  G.wt:
                  <input
                    type="number"
                    name="gw"
                    value={formData.gw}
                    onChange={handleChange}
                  />
                </label>
                <label>
                  N.wt:
                  <input
                    type="number"
                    name="nw"
                    value={formData.nw}
                    onChange={handleChange}
                  />
                </label>
                <label>
                  Kundan:
                  <input
                    type="number"
                    name="kundan"
                    value={formData.kundan}
                    onChange={handleChange}
                  />
                </label>
                <label>
                  K-amt:
                  <input
                    type="number"
                    name="k_amt"
                    value={formData.k_amt}
                    onChange={handleChange}
                  />
                </label>
                <label>
                  Moti:
                  <input
                    type="number"
                    name="moti"
                    value={formData.moti}
                    onChange={handleChange}
                  />
                </label>
                <label>
                  M-amt:
                  <input
                    type="number"
                    name="m_amt"
                    value={formData.m_amt}
                    onChange={handleChange}
                  />
                </label>
                <label>
                  PO:
                  <input
                    type="number"
                    name="po"
                    value={formData.po}
                    onChange={handleChange}
                  />
                </label>
                <label>
                  P-amt:
                  <input
                    type="number"
                    name="p_amt"
                    value={formData.p_amt}
                    onChange={handleChange}
                  />
                </label>
                <label>
                  PCS:
                  <input
                    type="number"
                    name="pcs"
                    value={formData.pcs}
                    onChange={handleChange}
                  />
                </label>
                <label>
                  Supplier:
                  <input
                    type="text"
                    name="supplier"
                    value={formData.supplier}
                    onChange={handleChange}
                  />
                </label>
                <label>
                  Image:
                  <input
                    type="file"
                    name="image"
                    onChange={handleChange}
                    style={{ border: "none" }}
                  />
                </label>
                <Button className="add_item" type="submit" variant="contained">
                  Add Item
                </Button>
              </form>
           </div>
            <div className="table_item">
            <TableContainer component={Paper} style={{ maxHeight: "500px" }}>
             <Table>
              <TableHead>
                <TableRow>
                  <TableCell>No.</TableCell>
                  <TableCell align="center">Code</TableCell>
                  <TableCell align="center">G.wt</TableCell>
                  <TableCell align="center">N.wt</TableCell>
                  <TableCell align="center">Kund</TableCell>
                  <TableCell align="center">K.amt</TableCell>
                  <TableCell align="center">Moti</TableCell>
                  <TableCell align="center">M.amt</TableCell>
                  <TableCell align="center">PO</TableCell>
                  <TableCell align="center">P.amt</TableCell>
                  <TableCell align="center">Pcs</TableCell>
                  <TableCell align="center">Supp</TableCell>
                  <TableCell align="center">Image</TableCell>
                  <TableCell align="center">Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {loading ? (
                  <TableRow>
                    <TableCell colSpan={14} align="center">
                      <CircularProgress size={30} style={{ color: "#7451f8" }} />
                    </TableCell>
                  </TableRow>
                ) : (
                  filteredStockItems
                    .map((item, index) => (
                      <TableRow key={item.id}>
                        <TableCell component="th" scope="row">
                          {index + 1}
                        </TableCell>
                        <TableCell align="center">{item.code}</TableCell>
                        <TableCell align="center">{item.gw}</TableCell>
                        <TableCell align="center">{item.nw}</TableCell>
                        <TableCell align="center">{item.kundan}</TableCell>
                        <TableCell align="center">{item.k_amt}</TableCell>
                        <TableCell align="center">{item.moti}</TableCell>
                        <TableCell align="center">{item.m_amt}</TableCell>
                        <TableCell align="center">{item.po}</TableCell>
                        <TableCell align="center">{item.p_amt}</TableCell>
                        <TableCell align="center">{item.pcs}</TableCell>
                        <TableCell align="center">{item.supplier}</TableCell>
                        <TableCell align="center">
                          {item.image && (
                            <img
                              className="table_image"
                              src={item.image}
                              alt="Stock Item"
                              width="40"
                              height="40"
                              style={{ cursor: "pointer", borderRadius: "50%" }}
                              onClick={() => handleOpen(item.image)}
                              onError={handleImageError}
                            />
                          )}
                          {imageError && <div>Image not available</div>}
                        </TableCell>
                        <TableCell align="center">
                          <Button
                            className="delet_bttn"
                            onClick={() => handleDeleteStockItem(item.id)}
                          >
                            <DeleteIcon style={{ fontSize: 28, color: "#7451f8" }} />
                          </Button>
                          <Button
                            className="print_bttn"
                            variant="contained"
                            onClick={() => printItem(item)}
                            style={{ backgroundColor: "#6439ff", padding: "2px" }}
                          >
                            Print
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))
                )}
                {filteredStockItems.length === 0 && !loading && (
                  <TableRow>
                    <TableCell colSpan={14} align="center">
                      No items match your search
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
                {/* <TablePagination
                  rowsPerPageOptions={[10]} // Fixed to 10 rows per page
                  component="div"
                  count={filteredStockItems.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  showFirstButton={false} // Optional: hide first page button
                  showLastButton={false}  // Optional: hide last page button
                /> */}
              </TableContainer>
              <ImageModal
                open={open}
                handleClose={handleClose}
                imageUrl={selectedImage}
              />
            </div>
          </div>
        </div>
      </div>
      {selectedItem && (
        <div style={{ display: "none" }}>
          <div ref={printRef}>
            <div className="label-content" style={{ 
              width: "100mm", 
              height: "13mm", 
              display: "flex", 
              flexDirection: "row", 
              justifyContent: "space-between", 
              alignItems: "center", 
              fontSize: "8px",
              fontWeight: "800",
              padding: "2mm",
              marginTop: "-3px" 
              // boxSizing: "border-box"
            }}>
              <div>
                <p style={{ margin: 0 }}></p>
              </div>
              <div>
                <p style={{ margin: 0 }}></p>
              </div>
              <div style={{ flex: 0.5 }}> {/* Takes up remaining space */}
                <p style={{ margin: 0, textAlign: "right", }}>{selectedItem.supplier}</p>
              </div>
              <div style={{ marginLeft: "35px", marginRight: "-10px"}}>
                <p style={{ margin: 0 }}>Code : {selectedItem.code}</p>
                <p style={{ margin: 0 }}>G.wt. : {selectedItem.gw}</p>
                <p style={{ margin: 0 }}>N.wt. : {selectedItem.nw}</p>
              </div>
              <div style={{ marginLeft: "10px", marginRight: "-25px"}}>
                <QRCodeCanvas value={String(selectedItem.nw)} size={20} />
              </div>
              <div style={{ marginLeft: "30px", paddingRight: "1px", borderRight: "1px solid #000"}}>
                <p style={{ margin: 0 }}>K ={selectedItem.kundan}</p>
                <p style={{ margin: 0 }}>M ={selectedItem.moti}</p>
                <p style={{ margin: 0 }}>P ={selectedItem.po}</p>
              </div>
              <div style={{ marginLeft: "-12px"}}>
                <p style={{ margin: 0 }}>K ={selectedItem.k_amt}</p>
                <p style={{ margin: 0 }}>M ={selectedItem.m_amt}</p>
                <p style={{ margin: 0 }}>P ={selectedItem.p_amt}</p>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default StockItemForm;
